module.exports = __webpack_public_path__ + "static/media/Cross bite12.0c5b3026.png";